<div class="overlay"  *ngIf="isLoading | async">
  <div class="spinner">
      <i class="fa fa-pulse fa-spinner fa-3x"></i>
  </div>
</div>
